<template>
  <SettingsSection>
    <SettingsSectionTitle>
      Unlinked Refunds
    </SettingsSectionTitle>
    <SettingsSubsection>
      <form
        class="grid grid-cols-4 gap-4 overflow-hidden rounded-lg p-2"
        @submit="onSubmit"
      >
        <FormInputCheckbox
          name="isUnlinkedRefundsEnabled"
          label="Unlinked Refunds Enabled"
          class="col-span-4"
        />
        <FormInputPrice
          name="unlinkedRefundsSingleMaximum"
          label="Maximum Refund Amount"
          class="col-span-4"
        />
        <FormInputPrice
          name="unlinkedRefundsDailyMaximum"
          label="Maximum Daily Refund Amount"
          class="col-span-4"
        />
        <div class="col-span-4 flex justify-end">
          <FormSubmitButton>Save</FormSubmitButton>
        </div>
        <template v-if="false">
          <div class="absolute inset-0 bg-background-fg/8">
          </div>
        </template>
      </form>
    </SettingsSubsection>
  </SettingsSection>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate"

const {
  isUnlinkedRefundsEnabled,
  unlinkedRefundsDailyMaximum,
  unlinkedRefundsSingleMaximum,
  setUnlinkedRefundsSettings,
} = useTenant()

const { handleSubmit } = useForm({
  initialValues: reactiveComputed(() => ({
    isUnlinkedRefundsEnabled:
      isUnlinkedRefundsEnabled.value,
    unlinkedRefundsDailyMaximum:
      unlinkedRefundsDailyMaximum.value,
    unlinkedRefundsSingleMaximum:
      unlinkedRefundsSingleMaximum.value,
  })),
})

const isSubmitting = ref(false)
const onSubmit = handleSubmit(async (formValues) => {
  isSubmitting.value = true
  try {
    const newUnlinkedRefundsSettings =
      await updateUnlinkedRefundsSettings(
        formValues.isUnlinkedRefundsEnabled
          ? formValues
          : {
              isUnlinkedRefundsEnabled:
                formValues.isUnlinkedRefundsEnabled,
              unlinkedRefundsDailyMaximum: null,
              unlinkedRefundsSingleMaximum: null,
            }
      )

    setUnlinkedRefundsSettings(newUnlinkedRefundsSettings)
    toast.success("Unlinked Refund settings updated")
  } catch (error) {
    toast.error("Failed to update Unlinked Refund settings")
    throw error
  } finally {
    isSubmitting.value = false
  }
})
</script>
